/**
 * @generated SignedSource<<0249c3df699000ea346810169d33eec3>>
 * @relayHash 0bb8bcf12bd3013f6b132beefd35dab5
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 4758b0872aac7b80c284bd19fa273b8db61fb90c73a1b0875cb8997559eb51b2

import type { ConcreteRequest } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type GovernanceProjectsAdminQuery$variables = {
  cloudId: string;
};
export type GovernanceProjectsAdminQuery$data = {
  readonly jira: {
    readonly projectPolicies: {
      readonly nodes: ReadonlyArray<{
        readonly id: string;
        readonly " $fragmentSpreads": FragmentRefs<"PolicyOption_policy">;
      } | null> | null;
      readonly " $fragmentSpreads": FragmentRefs<"DefaultPolicyToggle_projectPolicies">;
    } | null;
  } | null;
};
export type GovernanceProjectsAdminQuery = {
  response: GovernanceProjectsAdminQuery$data;
  variables: GovernanceProjectsAdminQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "cloudId",
    "variableName": "cloudId"
  },
  {
    "kind": "Literal",
    "name": "first",
    "value": 3
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "id"
},
v3 = {
  "kind": "ScalarField",
  "name": "isDefault"
},
v4 = {
  "kind": "ScalarField",
  "name": "name"
},
v5 = {
  "kind": "ScalarField",
  "name": "totalCount"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "GovernanceProjectsAdminQuery",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v1/*: any*/),
            "concreteType": "JiraProjectPolicyConnection",
            "kind": "LinkedField",
            "name": "projectPolicies",
            "plural": false,
            "selections": [
              {
                "kind": "FragmentSpread",
                "name": "DefaultPolicyToggle_projectPolicies"
              },
              {
                "concreteType": "JiraProjectPolicy",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                  (v2/*: any*/),
                  {
                    "kind": "FragmentSpread",
                    "name": "PolicyOption_policy"
                  }
                ]
              }
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "GovernanceProjectsAdminQuery",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v1/*: any*/),
            "concreteType": "JiraProjectPolicyConnection",
            "kind": "LinkedField",
            "name": "projectPolicies",
            "plural": false,
            "selections": [
              {
                "concreteType": "JiraProjectPolicy",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                  (v3/*: any*/),
                  (v4/*: any*/),
                  (v2/*: any*/)
                ]
              },
              {
                "concreteType": "JiraProjectPolicy",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                  (v2/*: any*/),
                  (v4/*: any*/),
                  {
                    "kind": "ScalarField",
                    "name": "description"
                  },
                  (v3/*: any*/),
                  {
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "first",
                        "value": 20
                      }
                    ],
                    "concreteType": "JiraProjectPolicyAssociationConnection",
                    "kind": "LinkedField",
                    "name": "associatedProjects",
                    "plural": false,
                    "selections": [
                      (v5/*: any*/),
                      {
                        "concreteType": "JiraProjectPolicyAssociation",
                        "kind": "LinkedField",
                        "name": "nodes",
                        "plural": true,
                        "selections": [
                          {
                            "concreteType": "JiraProjectPolicyRuleViolationConnection",
                            "kind": "LinkedField",
                            "name": "ruleViolations",
                            "plural": false,
                            "selections": [
                              (v5/*: any*/)
                            ]
                          }
                        ]
                      }
                    ],
                    "storageKey": "associatedProjects(first:20)"
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "4758b0872aac7b80c284bd19fa273b8db61fb90c73a1b0875cb8997559eb51b2",
    "metadata": {},
    "name": "GovernanceProjectsAdminQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "d7dcae3a844def56e48f358dc3a8e16f";

export default node;
